import { render, staticRenderFns } from "./ProgramPreview.vue?vue&type=template&id=71f1316a&scoped=true"
import script from "./ProgramPreview.vue?vue&type=script&lang=js"
export * from "./ProgramPreview.vue?vue&type=script&lang=js"
import style0 from "./ProgramPreview.vue?vue&type=style&index=0&id=71f1316a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1316a",
  null
  
)

export default component.exports